<template>
  <td v-html="html"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['model'],
    data() {
      return {
        giftName: null
      }
    },
    computed: {
      html () {
        return this.giftName !== null ?
          this.giftName :
          this.model.body !== null ?
          this.model.body :
          defaultNullHtml();
      }
    },
    mounted() {
      if (this.model.meta !== null && this.model.meta.giftId !== undefined) {
        this.$http.get('/api/v1/gift/'+this.model.meta.giftId+'/name').then(({data}) => {
          this.giftName = data;
        });
      }
    }
};
</script>
